import moment from 'moment'
import _ from 'underscore'
import op from 'object-path'
import CONSTANT from '../../../constant/order'
import ACONSTANT from '../../../constant/activity'

const payImg = require("../../../../image/order/unpaid.png")
const deliveryImg = require("../../../../image/order/delivering.png")
const receivedImg = require("../../../../image/order/received.png")
const signImg = require("../../../../image/order/sign.png")
const cancelImg = require("../../../../image/order/cancel.png")
const failImg = require("../../../../image/order/fail.png")
const closeImg = require("../../../../image/order/close.png")

const uugpendingImg = require('../../../../image/order/uugpending.png')
const uugfailImg = require('../../../../image/order/uugfail.png')

export const getReleaseTime = (start, end, timer) => {
  let duration =  moment.duration({from: start, to: +end});
    if (duration.asSeconds() === 0) {
      clearInterval(timer);
      timer = 0
      return '';
    }
    if (duration.asSeconds() < 0) {
        clearInterval(timer);
        timer = 0
        return '';
    }
    let seconds = duration.seconds() + '';
    if (seconds.length === 1) {
        seconds = '0' + seconds;
    }
    return Math.floor(duration.asMinutes()) + ':' + seconds;
}

export const getOrderStatusText = (context) => {
  const activeInfo = context.activeInfo
    switch (context.orderStatus) {
        case 0:
          if(!context.releaseTime) {
            return '已失效'
          }
          if(context.$route.name == 'userOrderDetail') {
            return '等待付款'
          }
          return '待付款'
        case 1:
          return '支付成功'
        case 2:
          return '已取消'
        case 3: //已失效
          if(context.$route.name == 'userOrderDetail') {
            return '订单取消'
          }
          return '已取消'
        case 4:
          if(context.productType == 2) {
            return '出票成功'
          }
          if(context.productType == 3 || context.productType == 4 || context.productType == 5) {
            return '充值成功'
          }
          // if(context.$route.name == 'userOrderDetail' && context.logisticsStatus == 1) {
          //   return '已签收'
          // }
          if(context.$route.name == 'userOrderDetail') {
            return '等待收货'
          }
          return '待收货'
        case 5:
          return '已退费'
        case 6:
          if(context.productType == 2) {
            return '待出票'
          }
          if(context.productType == 3 || context.productType == 4 || context.productType == 5) {
            return '待充值'
          }
          return '发货中'
        case 7:
          return '支付中'
        case 8:
          if(context.productType == 2) {
            return '待出票'
          }
          if(context.productType == 3 || context.productType == 4 || context.productType == 5) {
            return '等待充值'
          }
          if(context.$route.name == 'userOrderDetail') {
            return '等待发货'
          }
          return '待发货'
        case 9:
          return '订单未成功'
        case 10:
          return '退费中'
        case 11:
          // return '已签收'
          return '等待收货'
        case 12:
          return '售后中'
        case 13:
          if(context.productType == 2){
            if(context.$route.name == 'userOrderDetail') {
              let endDate = op(context.skuList[0].thirdOrderExtInfo.goodsInfo[0]).get('endDate')
              const now = +moment()
              if(now > moment.unix(endDate)) {
                return '放映结束'
              }
            }
            return '出票成功'
          }
          return '已完成'
        case 14:
          if(context.$route.name == 'userOrderDetail') {
            return '订单关闭'
          }
          return '已关闭'
        case 15:
          return '待审核'
        case 16:
          return '已关闭'
        default:
          return ''
      }
}


export const getAmount = (epayDetailList, epayType) => {
  return _.chain(epayDetailList).filter((num) => {return num.epayType == epayType}).pluck('epayAmount').reduce((memo, num) => {
    return memo + num
  }, 0).value()
}


export const getOrderStatusImg = context => {
  switch (context.orderStatus) {
    case 0:
    case 1:
    case 7:
    case 10:
      if (!context.releaseTime) {
        return cancelImg;
      }
      return payImg;
    case 2:
    case 3:
    case 5:
      return cancelImg;
    case 4:
      if(context.virtualProduct == 0){
        if(context.logisticsStatus == 0) {
          return deliveryImg
        }
        return receivedImg
      }
    case 6:
      return signImg
    case 8:
      if (context.activeInfo) {
        let groupStatus = context.uuActiveDetail.groupStatus
        if (groupStatus === ACONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_FAIL) {
          return uugfailImg
        }
        if (groupStatus === ACONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_PENDING) {
          return uugpendingImg
        }
        if (groupStatus === ACONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_OK) {
          return signImg
        }
      }
    case 11:
    case 12:
    case 13:
      return receivedImg;
    case 9:
    case 15:
    case 16:
      if (context.activeInfo && context.uuActiveDetail.groupStatus === ACONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_FAIL) {
        return uugfailImg
      }
      return failImg
    case 14:
      if (context.activeInfo && context.uuActiveDetail.groupStatus === ACONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_FAIL) {
        return uugfailImg
      }
      return closeImg
    default:
      break;
  }
}
export const getOrderStatusTip = context => {
  const orderStatus = context.orderStatus
  const productType = context.productType
  const activeInfo = context.activeInfo
  switch(orderStatus) {
    case 0:
      if(!context.releaseTime) {
        return ''
      }
      return `剩余时间 ${context.releaseTime}`
    case 4:
    case 11:
      // if(context.logisticsStatus == 1) {
        const now = +moment()
        const end = moment.unix(context.endReceiptTime)
        let duration = moment.duration({from: now, to: +end})
        if (duration.asSeconds() <= 0) {
          return '';
        }
        return duration.get('days') + '天' + duration.get('hours') + '小时' + duration.get('minutes') + '分后将自动确认收货'
      // }
      // return ''
    case 6:
      if(productType == 1 || productType == 2) {
        return '预计1-15分钟内出票成功'
      }
      if(productType == 3 || productType == 4 || productType == 5) {
        return '预计1-15分钟内充值到账'
      }
      return ''
    case 8:
      if (activeInfo) {
        return ''
      }
      if(productType == 1 || productType == 2) {
        return '预计1-15分钟内出票成功'
      }
      if(productType == 3 || productType == 4 || productType == 5) {
        return '预计1-15分钟内充值到账'
      }
      return '预计2个工作日内发货'
    case 9:
      if (activeInfo) {
        return ''
      }
    case 10:
      return '已支付款项将在3-5个工作日内原路退回'
    default:
      return ''
  }
}

export const activeRestTime = (day, hour, minute) => {
  let ret = ''
  if (day && day > 2) {
     ret = `${day}天`
    if (hour) {
      ret += `${hour}小时`
    }
  } else if (day < 3 && !(day === 0 && hour === 0)) {
    let h = day * 24 + hour
    ret = `${h}小时`
  } else {
    minute ? ret = `${minute}分` : ret = '不足1分钟'
  }
  return ret
}

export const secondCountDown = (endAt, startAt) => {
  const end = moment.unix(endAt)
  const start = startAt ? +moment.now() : moment.unix(startAt)
  const diff = end - start
  const diffO = moment.duration(diff)
  let month = diffO.months()
  let day = diffO.days()
  let hour = diffO.hours()
  let minute = diffO.minutes()
  let second = diffO.seconds()
  let ret = ''
  if (diff < 0) {
    return '已结束'
  }
  if (day && day >= 1) {
    day = day * 24 + hour
    ret += `${day}:`
  } else if (hour >= 0) {
    hour < 10 ? hour = `0${hour}` : null
    ret += `${hour}:`
  }
  if (minute >= 0) {
    minute < 10 ? minute = `0${minute}` : null
    ret += `${minute}:`
  }
  second < 10 ? second = `0${second}` : null
  ret += `${second}`
  return ret
}
